import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CategorySelect from './CategorySelect';
import Button from './Button';
import TextInput from '../elements/TextInput';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as dashboardActions from "../../redux/actions/dashboard";
import useForceUpdate from 'use-force-update';
import MaterialIcon from "../elements/MaterialIcon.jsx";
import Dropdown from "../elements/Dropdown.jsx";
import { setCategoryAsSubgroupToCategoryModeActive } from "../../redux/actions/dashboard";
import { endSetAsSubgroupMode } from "../../redux/actions/dashboard.js";

AddCategoryForm.defaultProps = {
	type: null
};

function AddCategoryForm(props) {
	const { category, type, submittingCategories, cancel, categoryGroupType } = props;

	const dispatch = useDispatch();
	const forceUpdate = useForceUpdate();
	const [deletingCategory, updateDeletingCategory] = useState(false);
	const [advancedEditingActive, updateAdvancedEditingActive] = useState(false);
	const [showWhenNotUsed, updateShowWhenNotUsed] = useState(category.show_when_not_used);
	const [isMasterBudgetForChildren, updateIsMasterBudgetForChildren] = useState(category.is_master_budget_for_children);
	const [showingOptionsDropdown, updateShowingOptionsDropdown] = useState(false);
	const setCategoryAsSubgroupCategory = useSelector((state) => state.dashboard.setCategoryAsSubgroupCategory);


	const editCategory = useMemo(() => {
		return category.clone();
	}, [category]);

	useEffect(() => {
		if(type !== null) {
			editCategory.type = type;
		}
	}, [editCategory.type, type]);

	useEffect(() => {
		updateShowWhenNotUsed(editCategory.show_when_not_used);
	}, [editCategory.show_when_not_used]);

	function changeShowWhenNotUsed(event) {
		editCategory.show_when_not_used = !editCategory.show_when_not_used;
		updateShowWhenNotUsed(editCategory.show_when_not_used);
		// budgetMayHaveUpdated();
	}

	function changeIsMasterBudgetForChildren(event) {
		editCategory.is_master_budget_for_children = !editCategory.is_master_budget_for_children;
		updateIsMasterBudgetForChildren(editCategory.is_master_budget_for_children);
	}

	function showOptionsDropdown() {
		updateShowingOptionsDropdown(true);
	}

	function optionsDropdownClosed() {
		updateShowingOptionsDropdown(false);
	}

	const categoryDelete = useCallback(() => {
		props.categoryDelete(category);
	});

	const categoryDeleteUndo = useCallback(() => {
		props.categoryDeleteUndo(category);
	}, []);

	const setAsSubgroupClick = () => {
		dispatch(setCategoryAsSubgroupToCategoryModeActive(editCategory));
	};

	const categoryDeletePopupOpen = useCallback(() => {
		categoryDeletePopupChange(true);
	});

	const categoryDeletePopupClose = useCallback(() => {
		categoryDeletePopupChange(false);
	}, []);


	function categorySubmit(event) {
		const { categorySubmit } = props;
		if(event) {
			event.preventDefault();
		}
		categorySubmit(editCategory);
	}

	function changeAdvancedEditingActive() {
		updateAdvancedEditingActive(true);
	}

	function categoryFlipTransactions() {
		const { categoryFlipTransactions, categoryGroupType, category } = props;
		const result = confirm('Flip Transactions, Positive->Negative, Negative->Positive');
		if(!result) {
			return;
		}
		categoryFlipTransactions(category);
	}

	function categoryParentIdChange(result) {
		const { categorySubmit } = props;
		editCategory.parent_category_id = result.value;

		console.log('waht is this', categorySubmit);
		categorySubmit(editCategory)
			.then(() => {
				console.log('should end');
				dispatch(endSetAsSubgroupMode());
			});
		forceUpdate();
	}

	function categoryDeletePopupChange(to) {
		if(to) {
			if(confirm(`Hide Category "${category.name}"?`)) {
				categoryDelete();
			}
		}
	}

	function editChange(event) {
		const target = event.target;
		editCategory.update({
			[target.name]: target.value
		});
		forceUpdate();
	}

	function editOnBlur() {
		if(category.id && editCategory.hasChanges()) {
			categorySubmit();
		}
	}

	const updating = !!submittingCategories[category.id];

	const addButtonDisabled = updating || editCategory.name === '' || !editCategory.hasChanges();
	let categoryTextToShow = '';
	if(updating) {
		categoryTextToShow = 'Saving...';
	}
	else {
		if(category.id) {
			categoryTextToShow = 'Save';
		}
		else {
			categoryTextToShow = 'Add';
		}
	}
	return (
		<form autoComplete='off' onSubmit={categorySubmit} method='post'>
			<div className='row'>
				<div className='col s8 m6 category_name_container'>
					<div className='input-field'>
						<TextInput
							label={category.id ? 'Category Name' : `Add a Category to ${categoryGroupType.name}`}
							onChange={editChange}
							onBlur={editOnBlur}
							type='text'
							name='name'
							value={editCategory.name} />
					</div>
				</div>
				<div className='col s3'>
					<Button
						disabled={addButtonDisabled}
						submit
					>
						{categoryTextToShow}
					</Button>
					{' '}
				</div>
				<div className='col s1'>
					{!!category.id &&
					<CategoryDropdownOptions
						categoryFlipTransactions={categoryFlipTransactions}
						setAsSubgroupClick={setAsSubgroupClick}
						categoryDeletePopupOpen={categoryDeletePopupOpen}
						categoryDeleteUndo={categoryDeleteUndo}
						changeShowWhenNotUsed={changeShowWhenNotUsed}
						changeIsMasterBudgetForChildren={changeIsMasterBudgetForChildren}
						showingOptionsDropdown={showingOptionsDropdown}
						showOptionsDropdown={showOptionsDropdown}
						category={editCategory}
					/>
					}
				</div>
			</div>
			<div className='row'>
				{setCategoryAsSubgroupCategory && setCategoryAsSubgroupCategory.id === category.id &&
				<div className='col s4 m4 update_subgroup_container'>
					<label className='subgroup_container'>
						Move to Another Group
					</label>
					<CategorySelect
						blank='None'
						value={editCategory.parent_category_id}
						showSubCategories={false}
						onChange={categoryParentIdChange}
					/>
				</div>
				}
				<div className='col s8 m8'>
					{cancel &&
					<Button
						danger
						disabled={updating}
						onClick={cancel}>
						Cancel
					</Button>
					}
					{' '}
				</div>
			</div>
		</form>
	);
}

function CategoryDropdownOptions({
	                                 category,
	                                 showOptionsDropdown,
	                                 showingOptionsDropdown,
	                                 setAsSubgroupClick,
	                                 changeShowWhenNotUsed,
	                                 changeIsMasterBudgetForChildren,
	                                 categoryDeleteUndo,
	                                 categoryDeletePopupOpen,
	                                 categoryFlipTransactions,
                                 }) {

	const materialIconRef = useRef(null);
	const dropdownItems = useMemo(() => {
		return [
			{
				content: 'Flip Transactions',
				onClick: categoryFlipTransactions
			},
			{
				content: 'Move As Sub Group',
				onClick: setAsSubgroupClick

			},
			{
				content: category.deleted ? 'Undelete' : 'Delete',
				onClick: category.deleted ? categoryDeleteUndo : categoryDeletePopupOpen
			},
			{
				content: (<div>
					<label
						htmlFor={`show_always_${category.id}`}
						className='default'
						onChange={(e) => {
							event.stopPropagation();
						}}
						onClick={(e) => {
							e.preventDefault();
						}}
					>
						<input
							id={`show_always_${category.id}`}
							readOnly
							type="checkbox"
							checked={category.show_when_not_used}
						/>
						<span>Show Always</span>
					</label>
				</div>),
				onClick: changeShowWhenNotUsed
			},
			category.hasChildren() && {
				content: (<div>
					<label
						htmlFor={`is_master_budget_for_children_${category.id}`}
						className='default'
						onChange={(e) => {
							event.stopPropagation();
						}}
						onClick={(e) => {
							e.preventDefault();
						}}
					>
						<input
							id={`is_master_budget_for_children_${category.id}`}
							readOnly
							type="checkbox"
							checked={category.is_master_budget_for_children}
						/>
						<span>Is Master Budget For Children</span>
					</label>
				</div>),
				onClick: changeIsMasterBudgetForChildren
			},
		];
	});
	return (
		<Button
			small
			flat
			ref={materialIconRef}
			data-target={`category_dropdown_${category.id}`}
			onClick={showOptionsDropdown}
		>
			<MaterialIcon>
				more_vert
				{showingOptionsDropdown &&
				<Dropdown
					id={`category_dropdown_${category.id}`}
					constrainWidth={false}
					attachTo={materialIconRef}
					opened={true}
					items={dropdownItems}
				/>
				}
			</MaterialIcon>
		</Button>
	);
}

function mapStateToProps(state) {
	return {
		...state.dashboard,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...dashboardActions,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddCategoryForm);